(function () {
'use strict';

angular
    .module('styleVisualGuidelinesRoutes', [
        'styleVisualGuidelinesControllers'
    ])
    .config(router);

router.$inject = ['$stateProvider', '$urlRouterProvider'];

function router($stateProvider, $urlRouterProvider) {

    $stateProvider.state('visualGuidelines.style', {
        url: '/Style',
        views: {
            'mainContent@visualGuidelines': {
                templateUrl: require('./style.tpl.html'),
                controller: 'VisualGuidelinesStyleController'
            }
        }
    });
}
})();